import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import LoadingIcon from "../images/Loading_icon.gif";
import { UrlContext } from "../contexts/UrlContext";
import ViewProfiles from "../components/SharedProfiles/viewProfiles";
import ProfileViewPage from "../components/SharedProfiles/profileViewPage";
import ShareProfileHeader from "../components/SharedProfiles/shareProfileHeader";
import SharePorfileRow from "../components/SharedProfiles/shareProfilesRow";
import SuggestTimeSlot from "../components/SharedProfiles/suggestTimeSlot";
import CopyUrlComponent from "../components/SharedProfiles/copyUrlComponent";
import EmailToClient from "../components/SharedProfiles/eamilToClient";
import SelectProfile from "../components/SharedProfiles/selectProfile";
import { get } from "jquery";
import { set } from "date-fns";
import ComposeNewEmail from "../components/EmailUI/ComposeNewEmail";
import { use } from "react";

export default function SharedProfiles() {
  const { API_URL, URI } = useContext(UrlContext);
  const projectID = useParams().projectID;
  const [profiles, setProfiles] = useState([]);
  const [project, setProject] = useState("");
  const [projectType, setProjectType] = useState("");
  const [showRow, setShowRow] = useState(true);
  const [showDetails, setShowDetails] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isCalenderOpen, setIsCalendarOpen] = useState(false);
  const [url, setUrl] = useState("");
  const [openEmail, setOpenEmail] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [changedValue, setChangedValue] = useState(null);
  const [sharedProfileSummary, setSharedProfileSummary] = useState("");
  const [singleExpert, setSingleExpert] = useState(false);
  const [allExpert, setAllExpert] = useState(false);
  const [fromRequest, setFromRequest] = useState(false);
  const [showSelectProfile, setShowSelectProfile] = useState(false);
  const [refreshEvent, setRefreshEvent] = useState(false);
  const [sendTo, setSendTo] = useState([]);
  const [ccMail, setCcMail] = useState([]);
  const [projectName, setProjectName] = useState("");
  const [userName, setUserName] = useState("");
  const [clientDetail, setClientDetail] = useState({});
  const [defaultTemplate, setDefaultTemplate] = useState([]);
  const [clientLogs, setClientLogs] = useState([]);
  const [projectSupporters, setProjectSupporters] = useState([]);

  // Titles that should be removed
  const TITLES = [
    "Dr.", "Dr", 
    "Mr.", "Mr", 
    "Mrs.", "Mrs",
    "Ms.", "Ms",
    "Prof.", "Prof"
  ];

  function cleanName(fullName = "") {
    if (!fullName) return "";

    let name = fullName.trim();

    TITLES.forEach(title => {
      const regex = new RegExp("^" + title.replace(".", "\\.?") + "\\s+", "i");
      name = name.replace(regex, "");
    });

    return name.trim();
  };

  // ✅ Formal → always return LAST NAME
  function getFormalName(fullName = "") {
    const name = cleanName(fullName);
    const parts = name.split(" ").filter(Boolean);

    if (parts.length === 0) return "";
    return parts[parts.length - 1]; // last word = last name
  };

  // ✅ Informal → always return FIRST NAME
  function getInformalName(fullName = "") {
    const name = cleanName(fullName);
    const parts = name.split(" ").filter(Boolean);

    if (parts.length === 0) return "";

    // Ignore initials like "T" or "M"
    const firstRealName = parts.find(part => part.length > 1);
    return firstRealName || parts[0];
  };

  useEffect(() => {
    document.title = "Shared Profiles";
  }, []);

  useEffect(() => {
    getAllSlides();
  }, [refreshEvent]);

  useEffect(() => {
    const url = `${API_URL}get-client-logs/` + projectID;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          setClientLogs(data.response);
        } else {
          setClientLogs([]);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const getAllSlides = async () => {
    setProfiles([]);
    const requestBody = {
      projectID: projectID,
    };

    try {
      let modifiedUrl = "fetch-all-slide-data";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await response.json();
      if (responseData.status === "success") {
        const modifiedSlideList = responseData.slideList.map((slide) => {
          const totalRating =
            parseInt(slide.rating1) +
            parseInt(slide.rating2) +
            parseInt(slide.rating3) +
            parseInt(slide.rating4) +
            parseInt(slide.rating5);
          const MatchingCo = (totalRating / 25) * 100;
          const chartValue = {
            value: [
              parseInt(slide.rating1),
              parseInt(slide.rating2),
              parseInt(slide.rating3),
              parseInt(slide.rating4),
              parseInt(slide.rating5),
            ],
            badgeValue: `${MatchingCo}%`
          };
          return {
            ...slide,
            chartConfig: chartValue,
          };
        });
        setProfiles(modifiedSlideList);
        setProject(responseData.project);
        setProjectType(responseData.project.projectType);
        setSharedProfileSummary(responseData.sharedProfileSummary);
        setProjectSupporters(responseData.projectSupporters);

        setUrl(
          responseData.project.code
            ? `https://client.expertpowerhouse.com/${projectID}&code=${responseData.project.code}`
            : "Generate a new url"
        );
        getClientInfo(); // Fetch client info for email sending
        getClientOwnerSupporter(); // Fetch client and owner details for email sending
      } else {
        console.error("Failed to fetch existing expert events");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // Api to get client info
  const getClientInfo = () => {
    const url = `${API_URL}get-client-details-from-zoho`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ projectID }),
    })
      .then((res) => res.json())
      .then((data) => {
        setClientDetail(data.clientDetails);
      })
      .catch((err) => {
        console.log("error while getting client info");
      });
  };

  // API for fetching meeting timeslots
  const getClientOwnerSupporter = async () => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const requestBody = {
      projectID: projectID,
      token: token,
    };
    try {
      let modifiedUrl = "get-client-owner-supporter-details";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        setSendTo(responseData.clientOwnerMail.sendTo);
        setCcMail(responseData.clientOwnerMail.addCc);
        setProjectName(responseData.clientOwnerMail.projectName);
        setUserName(responseData.clientOwnerMail.userName);
      } else {
        console.error("Failed to get client and owner details");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // Api to log client mail and save additional emails
  const logEmailToClient = async (payload = {}) => {
    const { sendTo, ccMail } = payload;
    const requestBody = {
      projectID: projectID,
      sendTo,
      ccMail,
    };
    try {
      let modifiedUrl = "log-email-to-client";
      const response = await fetch(`${API_URL}${modifiedUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const responseData = await response.json();
      if (responseData.status === "success") {
        console.log("Email logged successfully");
      } else {
        console.error("Failed to get client and owner details");
      }
    } catch (error) {
      console.error("Error while calling the backend API:", error);
    }
  };

  // Prepare default email templates based on project type
  useEffect(() => {
    if (!url || url === "Generate a new url") return;
    if (projectType === "exp") {
      const templates = generateExpTemplates(
        clientDetail.lastName,
        userName,
        projectName,
        sharedProfileSummary
      );
      setDefaultTemplate(templates);
    } else if (projectType === "con" || projectType === "int") {
      const templates = generateConTemplates(
        clientDetail.lastName,
        userName,
        projectName
      );
      setDefaultTemplate(templates);
    }
  }, [
    projectType,
    clientDetail,
    userName,
    projectName,
    sharedProfileSummary,
    url,
  ]);

  const generateExpTemplates = (
    clientName,
    userName,
    projectName,
    sharedProfileSummary
  ) => [
    {
      lang: "en",
      label: "English",
      name: "Share Profile - English",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Dear ${getInformalName(clientName)},</div>
        <div><br></div>
        <div>Many thanks again for your request. You will find expert profiles following the below link.</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Below is the list of expert profiles with a short summary for a brief overview:</div>
        <div><br></div>
        ${sharedProfileSummary}
        <div>What do you think? Your feedback will be highly appreciated. If you want you can also select your preferences online and give availabilities for a call.</div>
        <div><br></div>
        <div>Best regards,</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:220px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      Profile anzeigen
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      View Profiles
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
    {
      lang: "de",
      label: "German",
      name: "Share Profile - German (Formal)",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Hallo Herr/Frau ${getFormalName(clientName)},</div>
        <div><br></div>
        <div>vielen Dank nochmals für Ihre Anfrage. Die Expertenprofile finden Sie unter folgendem Link:</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Nachfolgend erhalten Sie die Liste der Profile mit einer kurzen Zusammenfassung für einen schnellen Überblick:</div>
        <div><br></div>
        ${sharedProfileSummary}
        <div><br></div>
        <div>Über Ihr Feedback freuen wir uns sehr. Gerne organisieren wir im nächsten Schritt Expertengespräche mit den passenden Kandidaten.</div>
        <div><br></div>
        <div>Viele Grüße</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      Profile anzeigen
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      Profile anzeigen
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
    {
      lang: "de",
      label: "German",
      name: "Share Profile - German (Informal)",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Hallo ${getInformalName(clientName)},</div>
        <div><br></div>
        <div>vielen Dank nochmals für deine Anfrage. Die Expertenprofile findest du unter folgendem Link:</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Nachfolgend findest du die Liste der Profile mit einer kurzen Zusammenfassung für einen schnellen Überblick:</div>
        <div><br></div>
        ${sharedProfileSummary}
        <div><br></div>
        <div>Wir freuen uns sehr über dein Feedback. Gerne organisieren wir im nächsten Schritt Gespräche mit den passenden Kandidaten.</div>
        <div><br></div>
        <div>Viele Grüße</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      Profile anzeigen
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      Profile anzeigen
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
  ];

  const generateConTemplates = (clientName, userName, projectName) => [
    {
      lang: "en",
      label: "English",
      name: "Share Profile - English",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Dear ${getInformalName(clientName)},</div>
        <div><br></div>
        <div>Many thanks again for your request. You will find profiles following the below link.</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Your feedback will be highly appreciated and we will be very happy to set up get-to-know discussions with relevant candidates.</div>
        <div><br></div>
        <div>Best regards,</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:220px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      View Profiles
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      View Profiles
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
    {
      lang: "de",
      label: "German",
      name: "Share Profile - German (Formal)",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Hallo Herr/Frau ${getFormalName(clientName)},</div>
        <div><br></div>
        <div>vielen Dank nochmals für Ihre Anfrage. Die Profile finden Sie unter folgendem Link:</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Über Ihr Feedback freuen wir uns sehr. Gerne organisieren wir im nächsten Schritt Kennenlern-Gespräche mit passenden Kandidaten.</div>
        <div><br></div>
        <div>Viele Grüße</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      Profile anzeigen
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      Profile anzeigen
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
    {
      lang: "de",
      label: "German",
      name: "Share Profile - German (Informal)",
      subject: `expertpowerhouse | ${projectName}`,
      value: `
        <div>Hallo ${getInformalName(clientName)},</div>
        <div><br></div>
        <div>vielen Dank nochmals für deine Anfrage. Die Profile findest du unter folgendem Link:</div>
        {{BUTTON_DO_NOT_REMOVE}}
        <div><br></div>
        <div>Wir freuen uns sehr über dein Feedback. Gerne organisieren wir im nächsten Schritt Kennenlern-Gespräche mit passenden Kandidaten.</div>
        <div><br></div>
        <div>Viele Grüße</div>
        <div>${userName}</div>
      `,
      linkedButton: `
        <table width="100%" cellspacing="0" cellpadding="0" role="presentation" style="margin: 20px 0;">
          <tr>
            <td align="center">
              <!--[if mso]>
              <a href="${url}" style="text-decoration:none;">
                <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml"
                            xmlns:w="urn:schemas-microsoft-com:office:word"
                            href="${url}"
                            style="height:40px;v-text-anchor:middle;width:280px;" arcsize="10%"
                            stroke="f" fillcolor="#365561">
                  <w:anchorlock/>
                  <center>
                    <span style="color:#ffffff; font-family:Arial,sans-serif; font-size:14px; font-weight:bold;">
                      Profile anzeigen
                    </span>
                  </center>
                </v:roundrect>
              </a>
              <![endif]-->

              <!--[if !mso]><!-- -->
              <table cellspacing="0" cellpadding="0" role="presentation">
                <tr>
                  <td align="center" bgcolor="#365561" style="border-radius: 6px;">
                    <a href="${url}"
                      target="_blank"
                      style="
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        color: #ffffff;
                        text-decoration: none;
                        padding: 12px 24px;
                        display: inline-block;
                        font-weight: bold;
                      ">
                      Profile anzeigen
                    </a>
                  </td>
                </tr>
              </table>
              <!--<![endif]-->
            </td>
          </tr>
        </table>
      `,
    },
  ];

  const handleOpenEmail = () => {
    if (
      (!defaultTemplate || defaultTemplate.length === 0) &&
      url &&
      url.includes("http")
    ) {
      if (projectType === "exp") {
        const templates = generateExpTemplates(
          clientDetail.clientName,
          userName,
          projectName,
          sharedProfileSummary
        );
        setDefaultTemplate(templates);
      } else if (projectType === "con" || projectType === "int") {
        const templates = generateConTemplates(
          clientDetail.clientName,
          userName,
          projectName
        );
        setDefaultTemplate(templates);
      }
    }
    setOpenEmail(true);
  };

  // Api for registering click on profile
  const clickingOnProfile = async (expertID, message) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;

    const requestBody = {
      projectID: projectID,
      expertID: expertID,
      message: message,
    };

    fetch(`${API_URL}view-consultant-profile-from-cliet-portal`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.status === "success") {
          return;
        } else { return; }
      })
      .catch(() => console.log('Error while registering log') );
  };

  const getClientLog = async () => {
    fetch(`${API_URL}get-client-logs/` + projectID, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.json())
    .then((data) => {
      if (data.status == "success") {
        setClientLogs(data.response);
      } else {
        setClientLogs([]);
      }
    })
    .catch((err) => console.log(err));
  };

  const updateProfilesCallRequested = (selectedExpertIDs = [], value = true) => {
    const selectedIDSet = new Set(
      selectedExpertIDs.map((id) => String(id).trim())
    );

    setProfiles((prevProfiles) =>
      prevProfiles.map((profile) =>
        selectedIDSet.has(String(profile.expertID).trim())
          ? {
              ...profile,
              isCallRequested: value,
            }
          : profile
      )
    );
  };

  return (
    <>
      <ShareProfileHeader
        project={project}
        projectID={projectID}
        profiles={profiles}
        isChanged={isChanged}
        changedValue={changedValue}
        setIsCalendarOpen={setIsCalendarOpen}
        setAllExpert={setAllExpert}
        clickingOnProfile={clickingOnProfile}
        projectType={projectType}
      />

      <div>
        <CopyUrlComponent
          projectID={projectID}
          projectName={project?.name}
          projectSupporters={projectSupporters}
          url={url}
          setUrl={setUrl}
          handleOpenEmail={handleOpenEmail}
          logFunction={logEmailToClient}
        />
      </div>

      {profiles.length > 0 ? (
        <div>
          {showRow && (
            <div className="w-full flex flex-col items-center px-3 py-3">
              {profiles.map((data, index) => (
                <SharePorfileRow
                  key={`${data.projectID}-${data.expertID}`}
                  data={data}
                  index={index}
                  proj_id={projectID}
                  expert_id={data?.expertID}
                  projectType={projectType}
                  setShowRow={setShowRow}
                  setShowDetails={setShowDetails}
                  setCurrentSlide={setCurrentSlide}
                  isCalenderOpen={isCalenderOpen}
                  setIsCalendarOpen={setIsCalendarOpen}
                  isChanged={isChanged}
                  setIsChanged={setIsChanged}
                  setChangedValue={setChangedValue}
                  setSingleExpert={setSingleExpert}
                  setAllExpert={setAllExpert}
                  fromRequest={fromRequest}
                  setFromRequest={setFromRequest}
                  clickingOnProfile={clickingOnProfile}
                  clientLog={clientLogs}
                  profilesList={profiles}
                  markProfilesAsCallRequested={updateProfilesCallRequested}
                />
              ))}
            </div>
          )}
          {showDetails && (
            <ProfileViewPage
              expertID={profiles[currentSlide].expertID}
              projectID={projectID}
              profile={profiles[currentSlide]}
              setIsProfileView={setShowDetails}
              projectType={projectType}
              clickingOnProfile={clickingOnProfile}
              markProfilesAsCallRequested={updateProfilesCallRequested}
            />
          )}
          {isCalenderOpen && (
            <SuggestTimeSlot
              projectID={projectID}
              expertID={profiles[currentSlide].expertID}
              profile={profiles[currentSlide]}
              singleExpert={singleExpert}
              setSingleExpert={setSingleExpert}
              allExpert={allExpert}
              setAllExpert={setAllExpert}
              setIsCalendarOpen={setIsCalendarOpen}
              fromRequest={fromRequest}
              setFromRequest={setFromRequest}
              setShowSelectProfile={setShowSelectProfile}
              refreshEvent={refreshEvent}
              setRefreshEvent={setRefreshEvent}
            />
          )}
          {openEmail && (
            <ComposeNewEmail
              onClose={() => setOpenEmail(false)}
              defaultTo={sendTo}
              defaultCc={ccMail}
              defaultTemplates={defaultTemplate}
              logFunction={logEmailToClient}
              projectID={projectID}
            />
          )}
          {showSelectProfile && (
            <SelectProfile
              projectID={projectID}
              profiles={profiles}
              projectType={projectType}
              setShowSelectProfile={setShowSelectProfile}
              setIsCalendarOpen={setIsCalendarOpen}
              refreshEvent={refreshEvent}
              setRefreshEvent={setRefreshEvent}
            />
          )}
        </div>
      ) : (
        <div className="container-div">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "15%",
            }}
          >
            <i
              class="fa-solid fa-spinner fa-spin"
              style={{ fontSize: "100px", color: "#365561" }}
            ></i>
          </div>
        </div>
      )}
    </>
  );
}
